import React, { useState, useEffect, useRef } from "react";
import GlobalFunctions from "../Services/GlobalFunctions";
import "../App.css";
import Swal from "sweetalert2";

const IngresarPrest = (params) => {
  const glob = new GlobalFunctions();
  const [prest, setPrest] = useState({
    interes: 10,
    n_cuotas: 8,
    periodicidad: "semanal",
    tiempo_meses: 2,
    totalapagar: 240000,
    tt_abonos: 0,
    tt_saldo: 240000,
    valor_cuotas: 8,
    valorprestamo: 200000,
  });
  const options = ["diario", "semanal", "quincenal", "mensual"];
  const [calc, setCalc] = useState(false);

  useEffect(() => {
    calcularCredito();
  }, []);

  useEffect(() => {
    if (calc) {
      calcularCredito();
    }
  }, [prest]);

  function calcularCredito() {
    setCalc(false);
    let totalInteres = prest.tiempo_meses * (prest.interes / 100);
    let ncuotas = getPeriodNumber() * prest.tiempo_meses;
    let totalpagar =
      prest.valorprestamo * totalInteres + parseFloat(prest.valorprestamo);
    let valorcuotas = (totalpagar / ncuotas).toFixed(0);
    var e = new Date(prest.fecha_prest);
    e.setMonth(e.getMonth() + parseInt(prest.tiempo_meses));
    let saldo = parseInt(totalpagar) - parseInt(prest.tt_abonos);
    setPrest((valores) => ({
      ...valores,
      n_cuotas: ncuotas,
      totalapagar: totalpagar,
      tt_saldo: saldo,
      valor_cuotas: valorcuotas,
      vencimiento: glob.formatFecha(e),
    }));
  }

  function functionSetnMeses(event) {
    setCalc(true);
    setPrest((valores) => ({
      ...valores,
      tiempo_meses: event.target.value,
    }));
  }

  function getPeriodNumber() {
    let number = 0;
    switch (prest.periodicidad) {
      case "diario":
        number = 30;
        break;
      case "semanal":
        number = 4;
        break;
      case "quincenal":
        number = 2;
        break;
      case "mensual":
        number = 1;
        break;
    }
    return number;
  }

  function functionSetPeriodicidad(event) {
    setCalc(true);
    setPrest((valores) => ({
      ...valores,
      periodicidad: event.target.value,
    }));
  }

  function functionSetValorPrestamo(event) {
    setCalc(true);
    setPrest((valores) => ({
      ...valores,
      valorprestamo: event.target.value,
    }));
  }

  function functionSetInteres(event) {
    setCalc(true);
    setPrest((valores) => ({
      ...valores,
      interes: event.target.value,
    }));
  }

  function cambioValorCuotas(event) {
    setPrest((valores) => ({
      ...valores,
      valor_cuotas: event.target.value,
    }));
  }

  return (
    <div
      className="modal fade"
      id="prestamoModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              className="btn btn-dark"
              onClick={params.goAmortizado}
               data-dismiss="modal"
            >
              Amortizado
            </button>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
            ></button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <form id="Form_ingresar_prestamo">
                <div
                  style={{ textAlign: "center", marginBottom: "0.5em" }}
                  className="row"
                >
                  <div className="col-6">
                    Valor del prestamo:
                    <br />
                    <input
                      style={{ width: "8em" }}
                      className="form-control rounded"
                      type="number"
                      onChange={functionSetValorPrestamo}
                      name="valorprestamo"
                      id="input_prestamo"
                      value={prest.valorprestamo}
                    />
                  </div>
                  <div className="col-6 ">
                    Valor cuotas:
                    <br />
                    <input
                      className="form-control rounded"
                      type="number"
                      style={{ width: "8em" }}
                      onChange={cambioValorCuotas}
                      readOnly={params.prest == "" ? true : false}
                      name="valor_cuotas"
                      size="20"
                      value={prest.valor_cuotas}
                    />
                  </div>
                </div>
                <div style={{ textAlign: "center" }} className="row">
                  <div className="col-6 ">
                    Tiempo (meses):
                    <br />
                    <input
                      className="form-control rounded"
                      type="number"
                      min="1"
                      onChange={functionSetnMeses}
                      max="100"
                      name="tiempo_meses"
                      value={prest.tiempo_meses}
                    />
                  </div>
                  <div className="col-6 ">
                    Periodicidad:
                    <br />
                    <select
                      className="form-control rounded"
                      onChange={functionSetPeriodicidad}
                      value={prest.periodicidad}
                      name="periodicidad"
                    >
                      {options.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div
                  style={{ textAlign: "center", marginTop: "0.5em" }}
                  className="row"
                >
                  <div className="col-6 ">
                    N° cuotas:
                    <br />
                    <input
                      className="form-control rounded"
                      type="number"
                      name="n_cuotas"
                      min="0"
                      max="999"
                      id="input_n_cuotas"
                      readOnly
                      value={prest.n_cuotas}
                    />
                  </div>
                  <div className="col-6 ">
                    Interes (%):
                    <br />
                    <input
                      className="form-control rounded"
                      type="number"
                      onChange={functionSetInteres}
                      min="0"
                      max="99"
                      name="interes"
                      value={prest.interes}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IngresarPrest;
